module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0087.jpg?v=34dc4f40";